import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

interface WizardStepLinkProps {
  skipScan: boolean;
  deviceSerialNumber: string;
  clientEmail: string;
  isEmailValid: boolean;
  isLinking: boolean;
  onSerialChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onLink: () => void;
  onBack: () => void;
  validateSerialNumber: (serial: string) => boolean;
}

export function WizardStepLink({
  skipScan,
  deviceSerialNumber,
  clientEmail,
  isEmailValid,
  isLinking,
  onSerialChange,
  onEmailChange,
  onLink,
  onBack,
  validateSerialNumber,
}: WizardStepLinkProps) {
  return (
    <div className="p-fluid">
      <div className="p-field">
        <h3>Link Device to Your Account</h3>
        <p>The device will now be linked to your dealer account.</p>

        <div style={{ marginTop: "24px" }}>
          <label
            htmlFor="serial-number"
            style={{ marginBottom: "8px", display: "block" }}
          >
            Serial Number
          </label>
          {!skipScan ? (
            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  padding: "8px 12px",
                  border: "1px solid var(--davey-border)",
                  borderRadius: "3px",
                  backgroundColor: "var(--davey-bg-light)",
                  color: "var(--davey-text)",
                }}
              >
                <strong>{deviceSerialNumber}</strong>
              </div>
              <small
                className="p-d-block"
                style={{ marginTop: "4px", color: "var(--davey-text-secondary)" }}
              >
                This is automatically detected from the device name.
              </small>
            </div>
          ) : (
            <div style={{ marginBottom: "24px" }}>
              <InputText
                id="serial-number"
                value={deviceSerialNumber}
                onChange={(e) => onSerialChange(e.target.value)}
                disabled={isLinking}
                placeholder="Enter 8-digit serial number"
                style={{ width: "100%", marginBottom: "8px" }}
                className={
                  deviceSerialNumber && !validateSerialNumber(deviceSerialNumber)
                    ? "p-invalid"
                    : ""
                }
              />
              {deviceSerialNumber &&
                !validateSerialNumber(deviceSerialNumber) && (
                  <small style={{ color: "red" }}>
                    Serial number must be exactly 8 digits
                  </small>
                )}
            </div>
          )}
        </div>

        <div style={{ marginBottom: "24px" }}>
          <label
            htmlFor="client-email"
            style={{ marginBottom: "8px", display: "block" }}
          >
            Client&apos;s Email <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            id="client-email"
            type="email"
            required
            value={clientEmail}
            onChange={(e) => onEmailChange(e.target.value)}
            className={clientEmail && !isEmailValid ? "p-invalid" : ""}
            disabled={isLinking}
            placeholder="Enter your client's email"
            style={{ width: "100%" }}
          />
          {clientEmail && !isEmailValid && (
            <small style={{ color: "red" }}>
              Please enter a valid email address
            </small>
          )}
        </div>

        <div style={{ marginTop: "24px" }}>
          <Button
            label="Link Device"
            icon="pi pi-link"
            onClick={onLink}
            disabled={
              isLinking ||
              !deviceSerialNumber ||
              !validateSerialNumber(deviceSerialNumber) ||
              !isEmailValid
            }
            className="p-button-success"
            style={{ marginBottom: "10px", width: "100%" }}
          />
          <Button
            label="Back"
            icon="pi pi-arrow-left"
            onClick={onBack}
            className="p-button-secondary"
            disabled={isLinking}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}
